import PrimeHoldingContainer from "./PrimeHoldingContainer";
import PrimeHoldingStore from "./PrimeHoldingStore";

export default PrimeHoldingStore(PrimeHoldingContainer);